<template>
  <v-modal
    v-if="true"
    @hide-modal="$emit('hide-modal')"
    size="sm"
  >
    <template v-slot:title>
      <h3 class="text-danger">
        {{ $t('phrase.delete_account') }}
      </h3>
    </template>
    <template v-slot:body>
      <form method="post" @submit.prevent="deleteAccount()">
        <div class="mb-5">
          <v-text-input
            id="delete-account-email"
            label="phrase.your_email"
            type="email"
            v-model="formData.email"
            :required="true"
            :errors="errors.email"
          />
        </div>
        <p class="text-danger">
          {{ $t('sentence.delete_account_warning') }}
        </p>

        <div class="d-flex justify-content-end">
          <v-button
            id="delete-account-submit"
            text="phrase.delete_my_account"
            type="submit"
            style-type="danger"
            :loader="loader"
          />
        </div>
      </form>
    </template>
  </v-modal>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Modal from '@/common/components/Modal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import api from '@/common/api';
import { mapGetters } from 'vuex';
import { notify } from '@/common/utils/notify';

export default {
  name: 'DeleteAccountModal',
  components: {
    'v-button': Button,
    'v-modal': Modal,
    'v-text-input': TextInput,
  },
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      formData: {
        email: '',
      },
      errors: {},
      loader: {
        loading: false,
      },
    };
  },
  methods: {
    async deleteAccount() {
      if (this.formData.email !== this.user.username) {
        this.errors = { email: [this.$t('phrase.incorrect_email')] };
        return;
      }

      this.loader.loading = true;
      const response = await api.delete('users/current/', this.formData);
      if (response.status === 204) {
        notify('phrase.delete_account', 'sentence.delete_account_success');
        setTimeout(() => { document.location.href = '/login'; }, 2000);
      }
    },
  },
};
</script>
